import { createFileRoute } from '@tanstack/react-router';
import {
  billingDetailScreen,
  billingSearch,
  loadBillingMessages,
  loadBillingScreens,
} from '@/modules/billing/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/gestao-carteira/cobrancas/$billingId')({
  validateSearch: billingSearch,
  staticData: { screen: billingDetailScreen },
  loader: () => loadBillingMessages(),
  component: lazyScreen(loadBillingScreens, 'BillingDetailRouteScreen'),
});
